export const CommonFrontOfficeCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
];
